<template>
  <div>
    <!-- <general-top-bar :title="$t('gestiune.production')"></general-top-bar> -->
    <div id="outer-container">
        <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
            <div class="card-content">
                <div class="clearfix row pad-lf-10 pad-rg-10">
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isBonProduct }"
                      @click="openBonProduct"
                    >{{$t('gestiune.isBonProductie')}}</a>
                    <!-- <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isLot }"
                      @click="openLot"
                    >{{$t('gestiune.lot')}}</a> -->
                </div>
            </div>
        </div>
    </div>
    <div v-if="isBonProduct">
      <ManagementBonProduct :grouped-locations="groupedLocations" :gestiune-options="gestiuneOptions" />
    </div>
    <div v-if="isLot">
      <ManagementLot :grouped-locations="groupedLocations" :gestiune-options="gestiuneOptions" />
    </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import ManagementBonProduct from 'src/components/Dashboard/Views/Management/Nomenclator/ManagementBonProduct.vue'
  import ManagementLot from 'src/components/Dashboard/Views/Management/ManagementLot.vue'

  export default {
    components: {
      // GeneralTopBar,
      ManagementBonProduct,
      ManagementLot
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      gestiuneOptions: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        isBonProduct: true,
        isLot: false
      }
    },
    created () {
    },
    methods: {
      openBonProduct () {
        this.isBonProduct = true
        this.isLot = false
      },
      openLot () {
        this.isBonProduct = false
        this.isLot = true
      }
    }
  }
</script>

<style scoped>
.form-check {
display: flex;
gap: 10px;
align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
display: flex; /* Folosește flexbox pentru alinierea orizontală */
justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementProduction.vue